import type { ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type RiskWizardLayoutProps = {
  companyName?: string | null;
  mainProgressSlot?: ReactNode;
  sectorProgressSlot?: ReactNode;
  footerSlot?: ReactNode;
  narrow?: boolean;
  children: ReactNode;
};

function buildTitle(companyName?: string | null): string {
  if (!companyName?.trim()) return "Analiza de Risc";
  return `Analiza de Risc - ${companyName.trim()}`;
}

export function RiskWizardLayout({
  companyName,
  mainProgressSlot,
  sectorProgressSlot,
  footerSlot,
  narrow,
  children,
}: RiskWizardLayoutProps) {
  return (
    <div className="flex flex-col h-[calc(100dvh-3rem)] bg-stone-100">
      <header className="shrink-0 border-b border-gray-200 bg-white px-2 py-2 md:px-4 md:py-3">
        <h1
          className="font-heading text-base font-semibold md:text-lg text-gray-900 truncate"
          title={buildTitle(companyName)}
        >
          {buildTitle(companyName)}
        </h1>
      </header>

      <main className="flex-1 max-w-[100vw] overflow-y-auto">
        <div
          className={cn(
            "mx-auto px-2 py-3 space-y-3 md:px-4 md:py-6 md:space-y-4",
            narrow ? "max-w-4xl" : "max-w-[1650px]"
          )}
        >
          {mainProgressSlot}

          <Card>
            <CardContent className="p-3 space-y-4 md:p-6 md:space-y-6">
              {sectorProgressSlot}
              {children}
            </CardContent>
          </Card>
        </div>
      </main>

      {footerSlot && (
        <div className="shrink-0 border-t border-gray-200 bg-white px-4 py-3">
          {footerSlot}
        </div>
      )}
    </div>
  );
}
